<template>
    <div class="nav-button" :class="disabled ? 'nav-button--disabled' : ''">
        <span @click="handleClick">
            <span v-if="!isLoading">
                <img
                    v-svg-inline
                    class="nav-button__icon"
                    height="100%"
                    width="100%"
                    :class="type === 'back' ? 'nav-button__icon--back' : ''"
                    src="@/assets/ui/intro-button.svg"
                />
            </span>
        </span>
        <b-spinner 
            label="Loading..." 
            v-if="isLoading"
            class="align-middle"
        />
    </div>
</template>
<script>
export default {
    name: 'navButton',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'next'
        }
    },
    methods: {
        handleClick() {
            if(!this.disabled) {
                this.$emit('click')
            }
        }
    }
}
</script>
<style lang="scss">
    .nav-button {
        font-weight: bold;
        cursor: pointer;
        :focus {
            outline: 0;
        }
        &--disabled {
            cursor: not-allowed;
        }
        
        height: 100%;
        width: 100%;
    }

    .nav-button__icon {
        outline: 0;
        &--back {
            transform: rotate(180deg);
        }
    }
</style>